module.exports = __webpack_public_path__ + "img/Main2.d52e3da0.jpg";